<div class="dialog-wrapper">
  <h2 id="gsTitle" mat-dialog-title>
    You are being redirected to another page
  </h2>
  <mat-dialog-content class="mat-typography">
    <p id="gsDialogContent" tabIndex="0">

          Select <b style="color: #742C85;">Continue</b> to leave National Student Clearinghouse site and go to {{gradeScaleLink}} where you can get more information on your school's grading scale. {{gradeScaleLink}} has their own Terms and conditions and any information provided is subject to those terms.

    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="gsDialogCancelBtn" mat-stroked-button  color="primary"  mat-dialog-close>Cancel</button>
    <button id="gsDialogContinueBtn"  mat-raised-button color="primary" cdkFocusInitial (click)="onClickContinue()" mat-dialog-close>Continue</button>
  </mat-dialog-actions>
</div>
